import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { validateAddCustomerForm } from '../../utils/validation';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';
export default class CustomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      gst: "",
      pan_no: "",
      phone: "",
      email: "",
      address: "",
      status: "",
      hasError: false,
      errMsg: "",
      completed: false,
      loading: true,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      data: this.props.location.state?.customerData
    };
  }

  componentDidMount() {
    const { data } = this.state;
    if (data) {
      this.setState({
        name: data.name,
        gst: data.gst,
        pan_no: data.pan_no,
        phone: data.phone,
        email: data.email,
        address: data.address,
        status: data.status,
      });
    }
    setTimeout(() => {
      this.setState({ loading: false })
    }, 900)
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "phone" && value && !/^\d*$/.test(value)) {
      return;
    }
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  onSubmit = async (e) => {
    this.setState({ loading: true })
    e.preventDefault();
    const { name, gst, pan_no, phone, email, address, status, data } = this.state;
    const token = localStorage.getItem("token");
    const errors = validateAddCustomerForm(
      this.state.name, this.state.email, this.state.phone, this.state.address, this.state.gst, this.state.pan_no, this.state.status
    );
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in." });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    const customerData = { name, gst, pan_no, phone, email, address, status };
    try {
      if (data) {
        await axios.put(`/customer/${data.id}`, customerData, { headers });
        this.setState({
          toastMessage: "Customer updated successfully!",
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        });
      } else {
        await axios.post('/customer', customerData, { headers });
        this.setState({
          toastMessage: "Customer created successfully!",
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        });
      }
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/customer-list");
      }, 900);

    } catch (error) {
      console.error("Error adding customer:", error);
      let errorMessage = "Failed to add customer.";

      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data.error || "Validation error!";
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }
      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: "Customer not created!",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
    }
  };
  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/customer-list");
      this.setState({ loading: false });
    }, 500);
  }
  render() {
    const { data } = this.state;
    return (
      <div className="pt-4">
        < CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })
          }
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          < >
            {/* {this.state.hasError ? (
              <Alert variant="outline-danger" className="m-3">
                {this.state.errMsg}
              </Alert>
            ) : this.state.completed ? (
              <>
                <Loader />
                <Redirect to="/customer-list" />
              </>

            ) : null} */}

            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>{data?.id ? "Update" : "Add"} Customer</strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Customer Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder='Enter customer name'
                          value={this.state.name}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.name && <small className="text-danger">{this.state.errors.name}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder='Enter customer email'
                          value={this.state.email}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.email && <small className="text-danger">{this.state.errors.email}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Mobile</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone" placeholder='Enter customer mobile'
                          value={this.state.phone}
                          onChange={this.handleChange}
                          maxLength={10}
                          inputMode="numeric"
                          pattern="\d*"
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.phone && <small className="text-danger">{this.state.errors.phone}</small>}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">GST Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="gst" placeholder='Enter GST number'
                          value={this.state.gst}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.gst && <small className="text-danger">{this.state.errors.gst}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">PAN Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="pan_no" placeholder='Enter PAN number'
                          value={this.state.pan_no}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.pan_no && <small className="text-danger">{this.state.errors.pan_no}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Status</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          name="status"
                          value={this.state.status || ""}
                          onChange={this.handleChange}
                        >
                          <option value="" disabled>
                            Select Status
                          </option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.status && <small className="text-danger">{this.state.errors.status}</small>}
                      </span>
                    </Col>

                  </Row>
                  <Row>
                    <Col xs={12} md={8} lg={8}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          name="address"
                          placeholder='Enter customer address'
                          value={this.state.address}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.address && <small className="text-danger">{this.state.errors.address}</small>}
                      </span>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button

                      variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary"

                      type="submit" >
                      {data?.id ? "Update" : "Add"}
                    </Button>
                    <Button

                      variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel"

                      onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </>
        </CommonLoader>
      </div>
    );
  }
}
